export enum metricTitles {
  Sales = "Sales",
  Apply_Click = "Apply Click",
  Application = "Application",
  Add_to_carts = "Add to carts",
  Click_Throughs = "Click Throughs",
  Impressions = "Impressions",
  PageVistits = "Page Visits",
}
